import { createServerSideHelpers } from '@trpc/react-query/server';
import { ServerSidePropsContext } from 'root/src/client/v2/common/helpers/gsspHelpers';
import { createTRPCClient, httpBatchLink } from '@trpc/client';
import superjson from 'superjson';
import { getTRPCUrl } from 'root/src/client/v2/trpc/trpc';
export function getTRPCServerSideHelpers(context) {
    const gsspHelper = new ServerSidePropsContext(context);
    const proxyClient = createTRPCClient({
        links: [
            httpBatchLink({
                transformer: superjson,
                url: getTRPCUrl(),
                headers: {
                    Authorization: `Bearer ${gsspHelper.getAuthToken()}`,
                },
            }),
        ],
    });
    return createServerSideHelpers({
        client: proxyClient,
        transformer: superjson,
    });
}
